export const config = {
  apiKey: "AIzaSyBE8ykosFVeqTNGbMXNkq2jeTgxAo9AjKQ",
  authDomain: "maf-interactive-pap.firebaseapp.com",
  databaseURL: "https://maf-interactive-pap-default-rtdb.firebaseio.com",
  projectId: "maf-interactive-pap",
  storageBucket: "maf-interactive-pap.appspot.com",
  messagingSenderId: "515390720318",
  appId: "1:515390720318:web:456f4c4ac9ca15ef94846f"
};
  